import { FC } from 'react';
import cn from 'classnames';

import styles from './MultipleItemsSlider.module.scss';

import type { CustomDotProps } from '../config/declarations';

export const Dot: FC<CustomDotProps> = ({ onClick, active, autoPlaySpeed }) => (
  <button
    type="button"
    className={cn(
      styles.dot,
      { [styles.active]: active },
    )}
    onClick={(e) => {
      onClick?.();
      e.preventDefault();
    }}
  >
    <span
      className={cn(
        styles.dotFill,
        { [styles.active]: active },
      )}
      style={{
        animationDuration: active ? `${autoPlaySpeed}ms` : undefined,
      }}
    />
  </button>
);
